import { render, staticRenderFns } from "./AiRequestsProductCard.vue?vue&type=template&id=e30ed95a&scoped=true"
import script from "./AiRequestsProductCard.vue?vue&type=script&lang=js"
export * from "./AiRequestsProductCard.vue?vue&type=script&lang=js"
import style0 from "./AiRequestsProductCard.vue?vue&type=style&index=0&id=e30ed95a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30ed95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e30ed95a')) {
      api.createRecord('e30ed95a', component.options)
    } else {
      api.reload('e30ed95a', component.options)
    }
    module.hot.accept("./AiRequestsProductCard.vue?vue&type=template&id=e30ed95a&scoped=true", function () {
      api.rerender('e30ed95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AiAssistance/Components/AiRequestsProductCard.vue"
export default component.exports